import { useState } from 'react';
import { Button } from '@carbon/react';
import { Add, Undo, ChartLine } from '@carbon/react/icons';
import { useAtomValue, useSetAtom } from 'jotai';
import { PageHeader } from 'components/page-header';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from 'utils/page-title';
import { EntityDashboardContent } from './entity-dashboard-content';
import { LibraryAnalyticsPanel } from './analytics/library-analytics-panel';
import {
  listReconcileSummaryAtom,
  listUndoModalOpenAtom,
} from './use-entity-list-reconcile';

const EntityListPage = () => {
  const history = useHistory();
  // Undo Reconcile lives in the page header per the mock (top right, before
  // Create New Entity), while the reconcile flow itself is owned by the
  // dashboard content — bridged via atoms.
  const reconcileSummary = useAtomValue(listReconcileSummaryAtom);
  const setUndoModalOpen = useSetAtom(listUndoModalOpenAtom);
  const [analyticsOpen, setAnalyticsOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>{pageTitle('Entities')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Entities"
        actions={
          <>
            <Button
              kind="tertiary"
              size="sm"
              renderIcon={ChartLine}
              onClick={() => setAnalyticsOpen(true)}
            >
              Show analytics
            </Button>
            {reconcileSummary && (
              <Button
                kind="danger--tertiary"
                size="sm"
                renderIcon={(props) => <Undo size={16} {...props} />}
                onClick={() => setUndoModalOpen(true)}
              >
                Undo Reconcile
              </Button>
            )}
            <Button
              size="sm"
              renderIcon={Add}
              onClick={() => history.push('/entities/new')}
            >
              <span>Create New Entity</span>
            </Button>
          </>
        }
      />
      <EntityDashboardContent />
      <LibraryAnalyticsPanel
        open={analyticsOpen}
        onClose={() => setAnalyticsOpen(false)}
      />
    </>
  );
};

export { EntityListPage };
